import { render, staticRenderFns } from "./AboutSnsButtons.vue?vue&type=template&id=465ea170&scoped=true&"
import script from "./AboutSnsButtons.vue?vue&type=script&lang=js&"
export * from "./AboutSnsButtons.vue?vue&type=script&lang=js&"
import style0 from "./AboutSnsButtons.vue?vue&type=style&index=0&id=465ea170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ea170",
  null
  
)

export default component.exports